import { useEffect, useRef } from 'react';
import { useHistory } from 'context/HistoryContext';
import useChatStore from 'stores/chatStore';

/**
 * Custom hook to sync chat store events with history refetching
 * Automatically triggers history refetch when:
 * - A new conversation is created (first reply received)
 * - Classification completes
 * - Post-verification classification completes
 */
export const useChatHistorySync = () => {
  const { triggerRefetch } = useHistory();
  const prevConversationIdRef = useRef<string | null>(null);
  const prevProcessingStatusRef = useRef<string>('');

  const currentConversationId = useChatStore((state) => state.currentConversationId);
  const processingStatus = useChatStore((state) => state.processingStatus);

  // Monitor conversation ID changes (new conversation created)
  useEffect(() => {
    if (
      currentConversationId &&
      currentConversationId !== prevConversationIdRef.current &&
      !prevConversationIdRef.current
    ) {
      console.log('📚 [useChatHistorySync] New conversation created, triggering refetch');
      triggerRefetch();
    }
    prevConversationIdRef.current = currentConversationId;
  }, [currentConversationId, triggerRefetch]);

  // Monitor processing status changes (classification complete)
  useEffect(() => {
    if (
      prevProcessingStatusRef.current &&
      prevProcessingStatusRef.current !== 'idle' &&
      processingStatus === 'idle'
    ) {
      console.log('📚 [useChatHistorySync] Processing completed, triggering refetch');
      triggerRefetch();
    }
    prevProcessingStatusRef.current = processingStatus;
  }, [processingStatus, triggerRefetch]);
};
